<template>
  <v-container
    id="lock"
    class="fill-height"
    tag="section"
  >
    <v-row justify="center">
      <v-slide-y-transition appear>
        <v-card
          class="mt-6 mt-md-0"
          light
          max-width="100%"
          width="250"
        >
          <v-card-text class="text-center">
            <v-avatar
              class="mt-n12 mb-6 elevation-12"
              color="grey"
              size="88"
            >
              <v-img src="/logo.png" />
            </v-avatar>

            <div class="display-3 font-weight-light mb-3 text--darken-2 grey--text">
              Troody
            </div>

            <div class="display-2 font-weight-light mb-3 text--darken-2 grey--text">
              The Troody Portal
            </div>

            <pages-btn
              v-if="isLoggedIn"
              @click="signOut"
            >
              Logout out of {{ name }}
            </pages-btn>

            <div class="display-1 font-weight-light mb-3 text--darken-2 grey--text">
              For Access Contact <br>
              1.501.227.0194 <br>
              <a href="mailto:info@troodongroup.com">info@troodongroup.com</a>
            </div>
          </v-card-text>
        </v-card>
      </v-slide-y-transition>
    </v-row>
  </v-container>
</template>

<script>
  import {
    mapGetters,
    mapActions,
  } from 'vuex'

  export default {
    name: 'PagesAbout',

    components: {
      PagesBtn: () => import('./components/Btn'),
    },

    computed: {
      ...mapGetters('oidcStore', ['oidcUser']),

      name () {
        return this.oidcUser.given_name || this.oidcUser.name || this.oidcUser.preferred_username
      },

      isLoggedIn () {
        return this.oidcUser !== null && this.oidcUser !== undefined
      },
    },

    methods: {
      ...mapActions('oidcStore', [
        'signOutOidc',
      ]),

      handleProfileClick: function (details) {
        if (details.action === 'logout') {
          this.signOut()
        }
      },

      signOut: function () {
        this.signOutOidc()
      },

    },

  }
</script>
